import {createContext} from 'react';
import {ViewStyle} from 'react-native';

export const PopupContext = createContext<{
  open(content: JSX.Element, options?: PopupOptions): void,
  exit(): void,
  visible: boolean;
  reference: any;
  setRef(ref: React.RefObject<any>): void;
  setPosition?: (cor: {x: number, y: number} | undefined) => void
}>(null);

export interface PopupOptions {
  style?: ViewStyle,
  anchorPosition?: {x: number, y: number},
}
